import { COMPANY_NAME } from '../../../../../utils';
import { GetHeader } from '../types/get-header';

const THEME = process.env.REACT_APP_THEME;

const messages = {
  CBB: {
    selectProduct: `Select the first product you'd like ${COMPANY_NAME} to fund.`,
    noProductFound: 'We could not find a product with ASIN:',
    productFound: 'We found this product:',
    enterProductId: `Enter the ASIN of the product you'd like ${COMPANY_NAME} to fund.`,
    subHeader: `${COMPANY_NAME} Growth Plans provide financing for ecommerce stores based on the supply chain Lines you build for your product.`,
  },
  '8DATA': {
    selectProduct: `Select the first product you'd like to plan a supply chain for.`,
    noProductFound: 'We could not find a product with id:',
    productFound: 'We found this product:',
    enterProductId: `Enter the id of the product you'd like.`,
    subHeader: '',
  },
};

export function getHeader({
  hasSellerProducts,
  displayVerifyProduct,
  product,
}: GetHeader) {
  if (hasSellerProducts) {
    return messages[THEME].selectProduct;
  } else {
    if (displayVerifyProduct) {
      if (product?.name) {
        return messages[THEME].productFound;
      } else {
        return messages[THEME].noProductFound;
      }
    } else {
      return messages[THEME].enterProductId;
    }
  }
}

export function getSubHeader({
  hasSellerProducts,
}: {
  hasSellerProducts: boolean;
}) {
  if (hasSellerProducts) {
    return messages[THEME].subHeader;
  }
}
